module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("\n  Redirecting...\n")]), _vm._v(" "), _c('div', {
    ref: "loginContainer",
    staticStyle: {
      "padding": "0px",
      "border": "none",
      "margin": "0px",
      "width": "0px",
      "height": "0px"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3e3e452!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Callback.vue
// module id = 485
// module chunks = 2